export const loaderImages = [
  {
    height: 853,
    width: 1280,
    relativeUrl: '/v1668153943/images/Cruise/CCSBLQ061100_2_63.jpg',
  },
  {
    height: 853,
    width: 1280,
    relativeUrl: '/v1668153949/images/Cruise/CCSROM1R1105_2_63.jpg',
  },
  {
    height: 853,
    width: 1280,
    relativeUrl: '/v1668072509/images/Cruise/CHMMIA061020_2_63.jpg',
  },
];

export const globeLoaderImages = [
  {
    height: 853,
    width: 1280,
    relativeUrl: '/web/cruise-loader-globe/a.jpg',
  },
  {
    height: 853,
    width: 1280,
    relativeUrl: '/web/cruise-loader-globe/b.jpg',
  },
  {
    height: 853,
    width: 1280,
    relativeUrl: '/web/cruise-loader-globe/c.jpg',
  },
];
